module.exports = __webpack_public_path__ + "static/media/ic_AI_picture@2x.e5b61b3e.png";